var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "debentures" },
    [
      _c(
        "v-row",
        { staticClass: "flex-column", attrs: { align: "start" } },
        [
          _c("v-col", { staticClass: "d-flex flex-column align-left py-0" }, [
            _c("span", { staticClass: "text-filelds" }, [
              _vm._v("Risco de Crédito")
            ])
          ]),
          _c(
            "v-col",
            [
              _c("v-autocomplete", {
                staticClass: "select",
                attrs: {
                  items: _vm.entityCreditRisk,
                  disabled: _vm.loading,
                  loading: _vm.loading,
                  "item-text": "fullName",
                  "return-object": true,
                  placeholder: "Insira Risco de Crédito",
                  color: "secondary",
                  required: "",
                  outlined: "",
                  dense: "",
                  rounded: "",
                  height: "10",
                  filter: _vm.filterObject,
                  clearable: "",
                  attach: ""
                },
                on: { change: _vm.selectEntityCreditRisk },
                model: {
                  value: _vm.entityCR,
                  callback: function($$v) {
                    _vm.entityCR = $$v
                  },
                  expression: "entityCR"
                }
              })
            ],
            1
          ),
          _c("v-col", { staticClass: "d-flex flex-column align-left py-0" }, [
            _c("span", { staticClass: "text-filelds" }, [_vm._v("Custodiante")])
          ]),
          _c(
            "v-col",
            [
              _c("v-autocomplete", {
                staticClass: "select",
                attrs: {
                  items: _vm.custodians,
                  disabled: _vm.loading,
                  loading: _vm.loading,
                  "item-text": "fullName",
                  "item-value": "entityId",
                  placeholder: "Insira o custodiante",
                  color: "secondary",
                  required: "",
                  outlined: "",
                  dense: "",
                  rounded: "",
                  height: "10",
                  filter: _vm.filterObject,
                  clearable: "",
                  attach: "",
                  rules: [
                    function(v) {
                      return v != null || "Campo obrigatório"
                    }
                  ]
                },
                on: { change: _vm.saveCustodiante },
                model: {
                  value: _vm.custodiante,
                  callback: function($$v) {
                    _vm.custodiante = $$v
                  },
                  expression: "custodiante"
                }
              })
            ],
            1
          ),
          _c("v-col", { staticClass: "d-flex flex-column align-left py-0" }, [
            _c("span", { staticClass: "text-filelds" }, [
              _vm._v("Nome do Ativo")
            ])
          ]),
          _c(
            "v-col",
            [
              _c("v-autocomplete", {
                staticClass: "select",
                attrs: {
                  loading: _vm.loading,
                  items: _vm.ativos,
                  disabled: _vm.loading,
                  "return-object": "",
                  "item-text": "code",
                  "menu-props": { bottom: true, offsetY: true },
                  placeholder: "Selecione",
                  color: "secondary",
                  required: "",
                  dense: "",
                  outlined: "",
                  rounded: "",
                  filter: _vm.filterObject,
                  clearable: "",
                  attach: ""
                },
                on: { change: _vm.changeActive },
                model: {
                  value: _vm.ativo,
                  callback: function($$v) {
                    _vm.ativo = $$v
                  },
                  expression: "ativo"
                }
              })
            ],
            1
          ),
          _c("v-row", { staticClass: "d-flex flex-wrap flexx" }, [
            _c(
              "div",
              { staticClass: "bloco" },
              [
                _c(
                  "v-col",
                  { staticClass: "d-flex flex-column align-left py-0" },
                  [
                    _c("span", { staticClass: "text-filelds" }, [
                      _vm._v("Estratégia")
                    ])
                  ]
                ),
                _c("v-col", { staticClass: "column", attrs: { cols: "1" } }, [
                  _c("span", { staticClass: "btn" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.estrategia ? _vm.estrategia : "Automático") +
                        " "
                    )
                  ])
                ])
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "bloco" },
              [
                _c(
                  "v-col",
                  { staticClass: "d-flex flex-column align-left py-0" },
                  [
                    _c("span", { staticClass: "text-filelds" }, [
                      _vm._v("Indice referência")
                    ])
                  ]
                ),
                _c("v-col", { staticClass: "column", attrs: { cols: "1 " } }, [
                  _c("span", { staticClass: "btn" }, [
                    _vm._v(
                      " " + _vm._s(_vm.indice ? _vm.indice : "Automático") + " "
                    )
                  ])
                ])
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "bloco" },
              [
                _c(
                  "v-col",
                  { staticClass: "d-flex flex-column align-left py-0" },
                  [_c("span", { staticClass: "text-filelds" }, [_vm._v("FGC")])]
                ),
                _c("v-col", { staticClass: "column", attrs: { cols: "1" } }, [
                  _c("span", { staticClass: "btn" }, [
                    _vm._v(_vm._s(_vm.FGCDesc) + " ")
                  ])
                ])
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "bloco" },
              [
                _c(
                  "v-col",
                  { staticClass: "d-flex flex-column align-left py-0" },
                  [
                    _c("span", { staticClass: "text-filelds" }, [
                      _vm._v("Isenta de IR (Lei 12.431)")
                    ])
                  ]
                ),
                _c("v-col", { staticClass: "column", attrs: { cols: "1" } }, [
                  _c("span", { staticClass: "btn" }, [
                    _vm._v(" " + _vm._s(_vm.isentaIR) + " ")
                  ])
                ])
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "bloco" },
              [
                _c(
                  "v-col",
                  { staticClass: "d-flex flex-column align-left py-0" },
                  [
                    _c("span", { staticClass: "text-filelds" }, [
                      _vm._v("Indexador")
                    ])
                  ]
                ),
                _c("v-col", { staticClass: "column", attrs: { cols: "1" } }, [
                  _c("span", { staticClass: "btn" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.indexador ? _vm.indexador : "Automático") +
                        " "
                    )
                  ])
                ])
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "bloco" },
              [
                _c(
                  "v-col",
                  { staticClass: "d-flex flex-column align-left py-0" },
                  [
                    _c("span", { staticClass: "text-filelds" }, [
                      _vm._v(
                        _vm._s(
                          _vm.rateFeesDescription
                            ? _vm.rateFeesDescription
                            : "Taxa de Juros"
                        )
                      )
                    ])
                  ]
                ),
                _c("v-col", { staticClass: "column", attrs: { cols: "1" } }, [
                  _c("span", { staticClass: "btn" }, [
                    _vm._v(" " + _vm._s(_vm.juros) + " ")
                  ])
                ])
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "bloco" },
              [
                _c(
                  "v-col",
                  { staticClass: "d-flex flex-column align-left py-0" },
                  [
                    _c("span", { staticClass: "text-filelds" }, [
                      _vm._v("Data Aplicação")
                    ])
                  ]
                ),
                _c(
                  "v-col",
                  {
                    staticClass: "py-0 flex-grow-0 flex-shrink-1",
                    staticStyle: { padding: "0" }
                  },
                  [_c("DatePiker", { on: { change: _vm.saveDataAplicacao } })],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "bloco" },
              [
                _c(
                  "v-col",
                  { staticClass: "d-flex flex-column align-left py-0" },
                  [
                    _c("span", { staticClass: "text-filelds" }, [
                      _vm._v("Data Vencimento")
                    ])
                  ]
                ),
                _c(
                  "v-col",
                  { staticClass: "py-0", staticStyle: { padding: "0" } },
                  [
                    _c("DatePiker", {
                      attrs: { value: _vm.vencimento, disabled: true },
                      on: { change: _vm.save }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "bloco" },
              [
                _c(
                  "v-col",
                  { staticClass: "d-flex flex-column align-left py-0" },
                  [
                    _c("span", { staticClass: "text-filelds" }, [
                      _vm._v("P. U. da aplicação")
                    ])
                  ]
                ),
                _c(
                  "v-col",
                  { staticClass: "py-0", staticStyle: { padding: "0" } },
                  [
                    _c("ValorMonetario", {
                      attrs: { value: _vm.vPrecoUnitario },
                      on: { change: _vm.saveShareValue }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "bloco" },
              [
                _c(
                  "v-col",
                  { staticClass: "d-flex flex-column align-left py-0" },
                  [
                    _c("span", { staticClass: "text-filelds" }, [
                      _vm._v("Quantidade")
                    ])
                  ]
                ),
                _c(
                  "v-col",
                  { staticClass: "py-0", staticStyle: { padding: "0" } },
                  [
                    _c("ValorMonetario", {
                      attrs: { value: _vm.vQtd },
                      on: { change: _vm.saveShareQuantity }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "bloco" },
              [
                _c(
                  "v-col",
                  { staticClass: "d-flex flex-column align-left py-0" },
                  [
                    _c("span", { staticClass: "text-filelds" }, [
                      _vm._v("Total Investido (R$)")
                    ])
                  ]
                ),
                _c(
                  "v-col",
                  { staticClass: "py-0", staticStyle: { padding: "0" } },
                  [
                    _c("ValorMonetario", {
                      attrs: { value: _vm.vPrecoUnitarioQtd },
                      on: { change: _vm.saveInvestedValue }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }